import { globalLoadingSnackbarStateSelector, globalLoadingStackSelector } from "@src/state";
import { useRecoilState } from "recoil";

const useLoader = () => {
	const [loadingbarStack, setLoadingbarStack] = useRecoilState(globalLoadingStackSelector);
	const [snackbarState, setSnackbareState] = useRecoilState(globalLoadingSnackbarStateSelector);

	const decrementLoadingbarStack = () => {
		setLoadingbarStack(-1);
	};

	const withLoader = async <T>(func: Promise<T>, message = ""): Promise<T> => {
		setLoadingbarStack(1);
		if (message) {
			setSnackbareState(message);
		}
		let result;
		try {
			result = await func;
		} catch (error) {
			throw error;
		} finally {
			decrementLoadingbarStack();
			if (message) {
				setSnackbareState("");
			}
		}
		return result;
	};

	return withLoader;
};

export default useLoader;
